import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Trans } from '@lingui/macro'

import { Typography, Button, Column, Container, TextInput } from 'components'
import Logo from '../../components/Logo'
import Row from '../../components/Row'
import Toast from '../../components/Toast'

import * as routes from './../../settings/_routesSettings'
import { apiEndpoints } from '../../settings/_apiSettings'

import axios from '../../settings/axios'

class ForgotPassword extends Component {
  state = {
    email: '',
    msgError: '',
    step: 1,
  }

  handleEmail = (e) => {
    e.preventDefault()
    this.setState({ email: e.target.value })
  }

  emailSubmit = (e) => {
    e.preventDefault()

    axios.post(`${apiEndpoints.ACCOUNTS}${this.state.email}/password/`)
      .then(response => {
        if (response.status === 'OK') {
          this.setState({ step: 2 })

        }
      })
      .catch(err => {
        this.setState({ msgError: 'Verifique o e-mail digitado' })
      })
  }

  handleStepChange = (step) => {
    switch (step) {
    case 2:
      return (
        <Container isView>
          <Row justify="center">
            <Column colWidth={4}>
              <Typography type="title" Tag="h1" gutterBotton>
                <Trans>
                    Redefinir Senha
                </Trans>
              </Typography>
            </Column>
          </Row>
          <Row justify="center">
            <Column colWidth={4}>
              <Typography type="paragraph" Tag="p" gutterBotton>
                <Trans>
                    Enviamos um link para redefinir a sua senha no email:
                </Trans>
              </Typography>
            </Column>
          </Row>
          <Row justify="center">
            <Column colWidth={4}>
              <Typography className="bold" Tag="p" gutterBotton>
                {this.state.email}
              </Typography>
            </Column>
          </Row>
          <Row justify="center">
            <Column colWidth={4}>
              <Typography type="paragraph" Tag="p" gutterBotton>
                <Trans>
                    Caso você não receba o e-mail em alguns minutos, verifique a sua caixa de spam ou repita o processo.
                </Trans>
              </Typography>
            </Column>
          </Row>
          <Row justify="center">
            <Column colWidth={4}>
              <Link to={routes.LOGIN}>
                <Button text={(<Trans>OK</Trans>)}
                  type="submit"
                />
              </Link>
            </Column>
          </Row>
        </Container>
      )

    default:
      return (
        <Container isView>
          <Row justify="center">
            <Column colWidth={4}>
              <Typography type="title" Tag="h1" gutterBotton>
                <Trans>
                    Redefinir Senha
                </Trans>
              </Typography>
            </Column>
          </Row>
          {
            this.state.msgError !== '' && (
              <Row margin="1.5rem 0"
                justify='center'>
                <Column colWidth={5}>
                  <Toast variant="error"
                    message={this.state.msgError}
                  />
                </Column>
              </Row>
            )
          }
          <Row justify="center">
            <Column colWidth={4}>
              <Typography type="paragraph" Tag="p" gutterBotton>
                <Trans>
                    Informe seu email de cadastro no campo abaixo. Será enviado um email com o link para criar uma nova senha:
                </Trans>
              </Typography>
            </Column>
          </Row>
          <Row justify="center">
            <Column colWidth={4}>
              <form>
                <TextInput
                  autofocus={true}
                  name="email"
                  onInputChange={this.handleEmail}
                  placeholder="seuemail@mail.com.br"
                  required={true}
                  type="mail"
                  value={this.state.email}
                />
                <Row justify="center" margin="2.5rem 0 0" >
                  <Button text="Enviar" type="submit" onButtonClick={this.emailSubmit} />
                </Row>
              </form>
            </Column>
          </Row>
        </Container>
      )
    }
  }

  render() {
    return (
      <Container isView>
        <Row justify='center' margin='6.2rem 0 3.0rem'>
          <Column align='center' justify='center' colWidth={4}>
            <Column colWidth={3}>
              <div>
                <Logo fill="#1f35b5" 
                  onClickLogo={() => window.location.href = process.env.REACT_APP_INSTITUTIONAL_URL}
                />
              </div>
            </Column>
          </Column>
        </Row>
        {this.handleStepChange(this.state.step)}
      </Container>
    )
  }
}

const mapStateToProps = state => {
  return { state: state }
}
function actionFunction() { }
const mapDispatchToProps = dispatch => {
  return { onAction: (variable) => dispatch(actionFunction(variable)) }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)